<template>
    <v-container>
        An error occured
    </v-container>
</template>
<script>
export default {
    name: 'ErrorPage'
}
</script>